import { FormGridField } from "../../components/FormGrid";

export interface GroupDefinition {
    name: string;
    id: string;
    label: string;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildGroupDefinition({
    name,
    id,
    label,
}: {
    name: string;
    id: string;
    label: string;
}): GroupDefinition {
    return {
        name,
        id,
        label,
        buildFormGridField: _createGroup
    };
}

function _createGroup(): FormGridField {
    const {
        name,
        id,
        label
    } = this;

    return {
        name,
        fieldType: "group",
        fieldOptions: {
            id,
            inputType: "text",
            label
        },
        validationSchema: {},
        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
        formSpacing: true
    };
}
